import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const SampleTooltip = ({sampleInfo}) => { 
    if (sampleInfo === undefined) {
        return (<div></div>);
    } else {
        return (
            <div className="sample-tooltip">
              <div className="sample-name">{sampleInfo.name.trim()}</div>
              <div className="sample-tags">
                {sampleInfo.tags.map(tag => <div className="s-tag">{tag}</div>)}
              </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
  return {
      sampleInfo: state.audition.sampleTooltip
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SampleTooltip);
